// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[data-component='Button'] {
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: 'Roboto Mono', monospace;
  font-size: 12px;
  font-optical-sizing: auto;
  font-weight: 400;
  font-style: normal;
  border: none;
  background-color: #ececf1;
  color: #101010;
  border-radius: 1000px;
  padding: 8px 24px;
  min-height: 42px;
  transition: transform 0.1s ease-in-out, background-color 0.1s ease-in-out;
  outline: none; }
  [data-component='Button'].button-style-action {
    background-color: #101010;
    color: #ececf1; }
    [data-component='Button'].button-style-action:hover:not([disabled]) {
      background-color: #404040; }
  [data-component='Button'].button-style-alert {
    background-color: #f00;
    color: #ececf1; }
    [data-component='Button'].button-style-alert:hover:not([disabled]) {
      background-color: #f00; }
  [data-component='Button'].button-style-flush {
    background-color: rgba(255, 255, 255, 0); }
  [data-component='Button'][disabled] {
    color: #999; }
  [data-component='Button']:not([disabled]) {
    cursor: pointer; }
  [data-component='Button']:hover:not([disabled]) {
    background-color: #d8d8d8; }
  [data-component='Button']:active:not([disabled]) {
    transform: translateY(1px); }
  [data-component='Button'] .icon {
    display: flex; }
    [data-component='Button'] .icon.icon-start {
      margin-left: -8px; }
    [data-component='Button'] .icon.icon-end {
      margin-right: -8px; }
    [data-component='Button'] .icon svg {
      width: 16px;
      height: 16px; }
  [data-component='Button'].icon-red .icon {
    color: #cc0000; }
  [data-component='Button'].icon-green .icon {
    color: #009900; }
  [data-component='Button'].icon-grey .icon {
    color: #909090; }
  [data-component='Button'].icon-fill svg {
    fill: currentColor; }
`, "",{"version":3,"sources":["webpack://./src/pages/pages/assistant/components/button/Button.scss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qCAAqC;EACrC,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,yEAAyE;EACzE,aAAa,EAAA;EACb;IAEE,yBAAyB;IACzB,cAAc,EAAA;IAAd;MAEE,yBAAyB,EAAA;EAA7B;IAKE,sBAAsB;IACtB,cAAc,EAAA;IAHd;MAKE,sBAAsB,EAAA;EAH1B;IAQE,wCAAwC,EAAA;EAN1C;IAUE,WAAW,EAAA;EARb;IAYE,eAAe,EAAA;EAVjB;IAcE,yBAAyB,EAAA;EAZ3B;IAgBE,0BAA0B,EAAA;EAd5B;IAkBE,aAAa,EAAA;IAhBb;MAkBE,iBAAiB,EAAA;IAhBnB;MAmBE,kBAAkB,EAAA;IAjBpB;MAoBE,WAAW;MACX,YAAY,EAAA;EAlBhB;IAuBE,cAAc,EAAA;EArBhB;IAwBE,cAAc,EAAA;EAtBhB;IAyBE,cAAc,EAAA;EAvBhB;IA2BI,kBAAkB,EAAA","sourcesContent":["[data-component='Button'] {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-family: 'Roboto Mono', monospace;\n  font-size: 12px;\n  font-optical-sizing: auto;\n  font-weight: 400;\n  font-style: normal;\n  border: none;\n  background-color: #ececf1;\n  color: #101010;\n  border-radius: 1000px;\n  padding: 8px 24px;\n  min-height: 42px;\n  transition: transform 0.1s ease-in-out, background-color 0.1s ease-in-out;\n  outline: none;\n\n  &.button-style-action {\n    background-color: #101010;\n    color: #ececf1;\n    &:hover:not([disabled]) {\n      background-color: #404040;\n    }\n  }\n\n  &.button-style-alert {\n    background-color: #f00;\n    color: #ececf1;\n    &:hover:not([disabled]) {\n      background-color: #f00;\n    }\n  }\n\n  &.button-style-flush {\n    background-color: rgba(255, 255, 255, 0);\n  }\n\n  &[disabled] {\n    color: #999;\n  }\n\n  &:not([disabled]) {\n    cursor: pointer;\n  }\n\n  &:hover:not([disabled]) {\n    background-color: #d8d8d8;\n  }\n\n  &:active:not([disabled]) {\n    transform: translateY(1px);\n  }\n\n  .icon {\n    display: flex;\n    &.icon-start {\n      margin-left: -8px;\n    }\n    &.icon-end {\n      margin-right: -8px;\n    }\n    svg {\n      width: 16px;\n      height: 16px;\n    }\n  }\n\n  &.icon-red .icon {\n    color: #cc0000;\n  }\n  &.icon-green .icon {\n    color: #009900;\n  }\n  &.icon-grey .icon {\n    color: #909090;\n  }\n  &.icon-fill {\n    svg {\n      fill: currentColor;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
